export default "__VITE_ASSET__DpaUDLsb__"